import script from "./FilesStep.vue?vue&type=script&setup=true&lang=js"
export * from "./FilesStep.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./FilesStep.vue?vue&type=custom&index=0&blockType=styles&lang=sass&scoped=true"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__